import { Component, Inject, Input, OnDestroy, OnInit, TemplateRef } from '@angular/core';
import { LoaderEnum } from '@lib/core';
import { ENVIRONMENT_TOKEN } from 'libs/core/src/lib/injection.tokens';
import { ILoaderConfig, loadingAnimationTypes, LoaderConfig, loadingSize, loadingStyle } from 'libs/core/src/lib/model/loading/loading-config';
import { LoaderStatus } from 'libs/core/src/lib/model/loading/loading-status.enum';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  template: '',
  standalone: false
})
export class LoaderComponent implements OnInit, OnDestroy {
  @Input() id: string = LoaderEnum.MAIN;
  @Input() show: boolean = true;
  @Input() config: ILoaderConfig = new LoaderConfig();
  @Input() template: TemplateRef<any>;
  @Input() size: string;
  @Input() centerScreen: boolean = false;

  @Input('backdrop-position') public backdropPosition: string = 'fixed';

  canShow = false;
  protected defaultConfig: ILoaderConfig;
  public loadingAnimationTypes = loadingAnimationTypes;
  public loadingSize = loadingSize;
  public loadingStyle = loadingStyle;

  private destroy$ = new Subject<void>();

  constructor(@Inject(ENVIRONMENT_TOKEN) protected environment: any, protected loaderService: LoaderService) {
    this.defaultConfig = environment.loader;
  }

  ngOnInit() {
    this.setupConfig();
    this.subscribeToLoadingState();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private subscribeToLoadingState(): void {
    if (!this.id) {
      console.warn('LoaderComponent: No ID provided');
      return;
    }

    this.loaderService.loaderMapState$.pipe(takeUntil(this.destroy$)).subscribe((statusMap: Map<string, LoaderStatus>) => {
      this.updateCanShow(statusMap);
    });
  }

  private updateCanShow(statusMap: Map<string, LoaderStatus>): void {
    if (!statusMap || !this.id) {
      this.canShow = false;
      return;
    }

    const normalizedId = this.id.toLowerCase();
    const status = statusMap.get(normalizedId);
    this.canShow = status === LoaderStatus.pending;
  }

  protected setupConfig(): void {
    const tempConfig: ILoaderConfig = this.config ?? this.defaultConfig;

    for (const option in tempConfig) {
      if (this.config[option] != null) {
        continue;
      }

      if (this.size && option === 'size') {
        this.config[option] = this.size;
        continue;
      }

      this.config[option] = this.loaderService.loaderConfig[option] != null ? this.loaderService.loaderConfig[option] : this.defaultConfig[option];
    }
  }
}
